module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/business-units/hr/hr-actions/hr-actions.component.css
// module id = ./src/app/web/game/management/business-units/hr/hr-actions/hr-actions.component.css
// module chunks = main